export function initWindowFunctions(setup) {
    window.verticalBridge = {
        authenticate: setup === null || setup === void 0 ? void 0 : setup.authenticate,
        register: setup === null || setup === void 0 ? void 0 : setup.register,
        showBalances: setup === null || setup === void 0 ? void 0 : setup.showBalances,
        refreshBalances: setup === null || setup === void 0 ? void 0 : setup.refreshBalances,
        deposit: setup === null || setup === void 0 ? void 0 : setup.deposit,
        home: setup === null || setup === void 0 ? void 0 : setup.home,
        headless: setup === null || setup === void 0 ? void 0 : setup.headless,
        redirect: setup === null || setup === void 0 ? void 0 : setup.redirect,
        resize: setup === null || setup === void 0 ? void 0 : setup.resize,
    };
}
